import {t} from "@lingui/core/macro";
import {useContext} from "react";

import IconButton from "@khanacademy/wonder-blocks-icon-button";
import Tooltip from "@khanacademy/wonder-blocks-tooltip";
import {AppShellContext} from "@khan/shared-core/context";

import mathOperationsIcon from "@phosphor-icons/core/regular/math-operations.svg";

type MathInputIconButtonType = React.FunctionComponent<{
    disabled?: boolean;
    onClick?: () => void;
    title?: string;
    isMobile: boolean;
}>;

const MathInputIconButton: MathInputIconButtonType = ({
    disabled,
    onClick,
    title,
    isMobile,
}): React.ReactElement => {
    const {entrypoint} = useContext(AppShellContext);
    const iconSize = entrypoint === "classroom" ? "medium" : undefined;

    const icon = (
        <IconButton
            aria-label={title}
            disabled={disabled}
            icon={mathOperationsIcon}
            kind="tertiary"
            actionType="neutral"
            onClick={onClick}
            size={iconSize}
            testId="math-input-button"
        />
    );
    return !isMobile ? (
        <Tooltip
            content={t`Math keys`}
            forceAnchorFocusivity={false}
            placement="bottom"
        >
            {icon}
        </Tooltip>
    ) : (
        icon
    );
};
export {MathInputIconButton};
